module.exports = __webpack_public_path__ + "static/media/salesforce.703f1fc3.png";